import React, { useState, useCallback } from 'react';
import i18next from 'i18next';
import { Property } from '../../@types/vehicle-properties';
import {
  TableListItem,
  TableListKey,
  TableListValue,
  TableListBooleanPos,
  TableListBooleanNeg,
} from '../../StyledComponents/TableList';
import { IconCheck, IconCancel } from '../../StyledComponents/Icon';
import { SrOnly } from '../../StyledComponents/SrOnly';
import { ButtonInline } from '../../StyledComponents/Button';
import Modal from '../../StyledComponents/Modal';
import Content from '../../StyledComponents/Content';

const formatValue = (value: Property['value'], unit: Property['unit']) => {
  if (typeof value === 'boolean') {
    return value ? (
      <TableListBooleanPos title={i18next.t('common.yes') || ''}>
        <SrOnly>{i18next.t('common.yes')}</SrOnly>
        <IconCheck block />
      </TableListBooleanPos>
    ) : (
      <TableListBooleanNeg title={i18next.t('common.no') || ''}>
        <SrOnly>{i18next.t('common.no')}</SrOnly>
        <IconCancel block />
      </TableListBooleanNeg>
    );
  }
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  if (!!value && !!unit) {
    return `${value} ${unit}`;
  }
  return value;
};

interface MetadataItemProps {
  name: string;
  hint?: string | null | undefined;
  value: Property['value'];
  unit: Property['unit'];
}

const MetadataItem = ({ name, hint, value, unit }: MetadataItemProps) => {
  const [foldout, setFoldout] = useState(false);
  const onToggleFoldout = useCallback(() => setFoldout(!foldout), [foldout]);

  const presentedValue = formatValue(value, unit);

  return (
    <TableListItem>
      <TableListKey>
        {hint ? (
          <ButtonInline
            onClick={onToggleFoldout}
            title={i18next.t('item.moreInfoAboutSubject', { subject: name }) || ''}
          >
            {name}
          </ButtonInline>
        ) : (
          name
        )}
      </TableListKey>
      <TableListValue>{value !== undefined ? presentedValue : i18next.t('item.dataNotAvailable')}</TableListValue>
      {hint && foldout && (
        <Modal title={name} onClose={onToggleFoldout}>
          <Content dangerouslySetInnerHTML={{ __html: hint }} />
        </Modal>
      )}
    </TableListItem>
  );
};

export default MetadataItem;
